import { generatePath } from 'react-router-dom';
import { EDIT_PATH, ARTICLES_ROUTE, ARTICLES_STATE_ROUTE, ORGANIZE_ROUTE, TEMPLATE_EDITOR_CONTENT_ROUTE, TEMPLATE_EDITOR_STYLES_ROUTE, INSIGHTS_ARTICLE_PATH, CHOOSE_TEMPLATE_ROUTE, TEMPLATE_EDITOR_ROUTE, TEMPLATE_TRANSLATE_MODAL_ROUTE, INSIGHTS_DASHBOARD_ROUTE, KB_ONBOARDING_PATH, ARTICLES_STATE_ROUTE_WITH_PARAM } from '../constants/RouteConstants';
export const getRootPath = () => '/';
export const getKnowledgeBaseRootPath = () => '/';
export const getKnowledgeBaseOnboardingPath = () => KB_ONBOARDING_PATH;
export const getArticlesPath = knowledgeBaseId => knowledgeBaseId ? generatePath(ARTICLES_ROUTE, {
  knowledgeBaseId
}) : ARTICLES_ROUTE;
export const getTemplateEditorPath = knowledgeBaseId => generatePath(TEMPLATE_EDITOR_ROUTE, {
  knowledgeBaseId
});
export const getArticlesStatePath = (knowledgeBaseId, state = 'all') => knowledgeBaseId ? generatePath(ARTICLES_STATE_ROUTE_WITH_PARAM, {
  knowledgeBaseId,
  state
}) : ARTICLES_STATE_ROUTE;
export const getArticlePerformancePath = articleId => `${INSIGHTS_ARTICLE_PATH}/${articleId}`;
export const getChooseTemplatePath = () => CHOOSE_TEMPLATE_ROUTE;
export const getInsightsDashboardPath = () => INSIGHTS_DASHBOARD_ROUTE;
export const getCustomizeTemplatePath = () => TEMPLATE_EDITOR_ROUTE;
export const getTranslateTemplatePath = () => TEMPLATE_TRANSLATE_MODAL_ROUTE;
export const getEditArticlePath = articleId => `${EDIT_PATH}/${articleId}`;
export const getOrganizePath = () => ORGANIZE_ROUTE;
export const getPublishedArticlePath = articleId => `${getArticlePerformancePath(articleId)}/published`;
export const getTemplateEditorContentPath = navItem => {
  return navItem ? `${TEMPLATE_EDITOR_CONTENT_ROUTE}/${navItem}` : TEMPLATE_EDITOR_CONTENT_ROUTE;
};
export const getTemplateEditorStylesPath = navItem => {
  return navItem ? `${TEMPLATE_EDITOR_STYLES_ROUTE}/${navItem}` : TEMPLATE_EDITOR_STYLES_ROUTE;
};